var exports = {
  "HM": "UserAreaSkeleton.module__userArea___cFVwWE",
  "nd": "UserAreaSkeleton.module__panel___cFVwWE",
  "zl": "UserAreaSkeleton.module__voicePanel___cFVwWE",
  "Qs": "UserAreaSkeleton.module__content___cFVwWE",
  "D_": "UserAreaSkeleton.module__identity___cFVwWE",
  "Ky": "UserAreaSkeleton.module__identityText___cFVwWE",
  "S7": "UserAreaSkeleton.module__nameRow___cFVwWE",
  "jf": "UserAreaSkeleton.module__statusRow___cFVwWE",
  "ne": "UserAreaSkeleton.module__controls___cFVwWE",
};

module.exports = exports;
